export const COMMON_CODE_ACTION = {
  GET_MOBILE_STATION: "GET_MOBILE_STATION_COMMON_CODE_ACTION",
  GET_PHONE_AREA: "GET_PHONE_AREA_COMMON_CODE_ACTION",
  GET_EMAIL_VENDOR: "GET_EMAIL_VENDOR_COMMON_CODE_ACTION",
  GET_CURRENCY: "GET_CURRENCY_COMMON_CODE_ACTION",
  GET_PAGE_RANGE: "GET_PAGE_RANGE_COMMON_CODE_ACTION",
  GET_QUANTITY: "GET_QUANTITY_COMMON_CODE_ACTION",
  GET_BANK_CODE: "GET_BANK_COMMON_CODE_ACTION",
};
